import axiosInstance from './axios'

export type MaintenanceStatus = {
  isMaintenanceActive: boolean
  activeMaintenances: Array<{
    type: string
    startTime: string
    endTime: string | null
    comment: string
  }>
  upcomingMaintenances: Array<{
    type: string
    startTime: string
    endTime: string | null
    comment: string
  }>
}

export const getMaintenanceStatus = (type?: string) => {
  const params = type ? { type } : undefined
  return axiosInstance.get<MaintenanceStatus>('/maintenance_schedules', {
    params,
  })
}
